import * as React from 'react'
import * as styles from '../style/index.scss'

export default () => (
    <div className={styles.termsWrap}>
        <h2>Privacy Statement</h2>
        <div>
            <div className={`${styles.marginB20} ${styles.marginTp10}`}>Lenovo recognizes that privacy is of great
                importance to individuals everywhere – our customers, website visitors, product users… everyone. This is
                why the responsible use and protection of personal and other information under our care is a core Lenovo
                value. To learn more about our privacy practices, please click any of the links below. If you have any
                further questions or concerns, please feel free to reach us at privacy@lenovo.com.
            </div>
            <div className={`${styles.marginB10}`}>The privacy statement was last updated on 02/07/2018.</div>

            <h3 className={`${styles.marginTp20} ${styles.marginB10}`}>About This Statement</h3>
            <div>
                <p>What this statement applies to:</p>
                <ul>
                    <li>Your privacy is important to Lenovo. This privacy statement applies to websites owned and
                        operated by Lenovo Group Ltd and its affiliated group companies ("Lenovo"). This policy
                        describes the information practices for Lenovo websites (such as https://www3.lenovo.com/us/en,
                        https://canada.lenovo.com/fr, https://www3.lenovo.com/ca/en/, http://lenovocareers.com,
                        http://blog.lenovo.com), including what type of information is collected, how the information is
                        used, with whom the information is shared, and how the information is protected. It also
                        describes your choices regarding use, access and correction of your personal information.
                    </li>
                </ul>
            </div>
            <div className={styles.marginTp20}>
                <p>What this statement does not apply to:</p>
                <ul>
                    <li>Lenovo websites may contain links to other websites. Lenovo is not responsible for the privacy
                        practices or the content of those other websites. Please also note that this statement does not
                        apply to information collected via Lenovo’s products and software as well as via some other
                        sources. To learn more about our product and software privacy practices, please visit the Lenovo
                        Product Privacy Statement here.
                    </li>
                </ul>
            </div>
            <div className={styles.marginTp20}>
                <p>Changes to this statement:</p>
                <ul>
                    <li>If we make a change to this statement, we will make previous versions available upon request so
                        that you can see when changes occurred and what they are. If we make any material changes to
                        this statement, we will notify you by means of a notice on this site or by an email (sent to the
                        e-mail address specified in your account) prior to the change becoming effective. Where we are
                        required by applicable data protection laws, we will also seek your consent to any material
                        changes that affect how we use your personal information. We encourage you to periodically
                        review this page for the latest information on our privacy practices.
                    </li>
                    <li>If you have an unresolved privacy or data use concern that we have not addressed satisfactorily,
                        please contact our U.S. based third-party dispute resolution provider at
                        https://feedback-form.truste.com/watchdog/request.
                    </li>
                </ul>
            </div>

            <h3 className={`${styles.marginTp20} ${styles.marginB10}`}>What information does Lenovo collect through its
                websites?</h3>
            <div>
                <p>Lenovo collects the following information from visitors to its websites:</p>
                <p>Information you provide to us voluntarily:</p>
                <ul>
                    <li>In general, you can visit Lenovo's websites without providing any identifying personal
                        information other than the information we collect automatically. There are times, however, when
                        we (or suppliers working for us) may need information from you. You may choose to give us
                        personal information in a variety of situations. For example, we may collect personal
                        information about you when you place an order with Lenovo, such as name, address, email address,
                        phone numbers, payment card information, information used to personalize a Lenovo product or
                        software experience, social security number (or equivalent national identification number), date
                        of birth and other information you choose to provide. Lenovo uses this information to facilitate
                        order processing and to enable us to contact you if a problem arises with your order.
                        Additionally, if you purchase a product requiring service, your personal information may be used
                        to obtain a credit report, if necessary. Please note that if you do not provide us with personal
                        information where required, we may not be able to provide you with the products or services you
                        have requested.
                    </li>
                    <li>We may ask you for and collect personal information at other times, including when you enter
                        sweepstakes, a contest or other promotion; when you subscribe to receive Lenovo marketing
                        communications or newsletters; when you complete surveys; when you participate in a user forum
                        or blog; or when you interact with Lenovo at a trade show, conference or similar event. We use
                        the information you provide to help us design and improve our website and our products, to
                        customize your online experience, to provide advice and purchase recommendations, and for other
                        purposes consistent with this policy.
                    </li>
                    <li>Lenovo also conducts research on our users' demographics (e.g. age, gender), interests, and
                        behavior based on the information provided to us when making a purchase, during a promotion,
                        from surveys and from our server log files. We do this to better understand and serve you. This
                        research is compiled and analyzed on an aggregated basis so as to prevent identification of
                        personal information relating to any one individual. Lenovo may share this aggregated data with
                        our suppliers.
                    </li>
                    <li>Finally, we may also ask for your personal information when you express an interest in
                        employment opportunities at Lenovo by submitting an application through our websites. The
                        information we collect from you will be made apparent at the time you are submitting your
                        application, and we will use this information only to evaluate your employment candidacy.
                    </li>
                </ul>
                <p>Information we collect automatically:</p>
                <ul>
                    <li>Our web server logs collect the domain names and certain related data of visitors to our web
                        sites automatically (such as their IP address or device identifier). This information is used to
                        measure number of visits, average time spent on a Lenovo website, pages viewed and website usage
                        information. We use this information to meet legal or regulatory requirements; to measure the
                        use of our sites; to improve the content of our sites; and to provide tailored advertisements.
                        This information is not used in a form that would enable direct identification of any of our
                        visitors. We may collect this information using cookies, as explained below under the section
                        "Does Lenovo user cookies, web beacons, analytics and related technologies for online
                        advertising and other purposes?”
                    </li>
                </ul>
                <p>Information we collect from other sources:</p>
                <ul>
                    <li>From time-to-time, we may supplement information you give us via a Lenovo website with
                        information from other sources, such as information validating your address or other available
                        information about businesses. This is to help us maintain the accuracy of the information we
                        collect and to help us provide a better service.
                    </li>
                </ul>
            </div>

            <h3 className={`${styles.marginTp20} ${styles.marginB10}`}>How does Lenovo use and share the information it
                collects through its websites?</h3>
            <div>
                <p>The following sections describe in more detail how Lenovo may use your personal information and with
                    whom we may share it. Depending on the type of Lenovo website you are visiting, one or more of the
                    sections may apply.</p>
                <p>We may share your personal information with contracted suppliers who are providing services to Lenovo
                    such as fulfilling orders and delivering packages, payment processing and providing customer
                    services. These suppliers are authorized to use your personal information only as necessary to
                    provide these services to us. In some cases, Lenovo uses suppliers to collect, use, analyze, and
                    otherwise process information on its behalf. It is Lenovo’s practice to require such suppliers to
                    handle information in a manner consistent with our policies.</p>
                <p>When You Request or Order Something:</p>
                <ul>
                    <li>If you request or order something from a Lenovo website, such as a product or service, a
                        callback, or specific marketing materials, we will use the information you provide to fulfill
                        your request. To help us do this, we may share information with others, for instance, other
                        parts of Lenovo, Lenovo's service providers, vendors, suppliers, financial institutions,
                        shipping companies, postal or government authorities (e.g., Customs authorities) involved in the
                        fulfillment of your request. In connection with a transaction, we may also contact you as part
                        of our customer satisfaction surveys or for market research purposes. To opt-out of surveys
                        and/or other market research communications, see the section below headed "Marketing."
                    </li>
                </ul>
                <p>Lenovo ID and Product Registration:</p>
                <ul>
                    <li>When you create a Lenovo ID or register your Lenovo product, we will collect information,
                        including personal information, about you and your Lenovo device(s). In addition to your Lenovo
                        ID, we may ask you to provide your name, email address, language and region/country, device
                        type/model, IP address, device serial number, date of device registration, and any activation
                        data about your operating system.
                    </li>
                    <li>We use your Lenovo ID to identify you when you use our online services, like our online store
                        and customer support site. If you wish to deactivate your Lenovo ID, you may do so at any time
                        by contacting privacy@lenovo.com.
                    </li>
                </ul>
                <p>Marketing:</p>
                <ul>
                    <li>The information you provide on certain Lenovo websites may also be used by Lenovo and selected
                        suppliers or partners for marketing purposes, such as when you subscribe to receive marketing
                        communications or newsletters, or when you enter sweepstakes, a contest or promotion. Before
                        this information is collected we may offer you the opportunity to choose whether or not to have
                        your information used in this way. You may choose to stop receiving our marketing communications
                        by following the unsubscribe instructions included in those communications, accessing the
                        marketing preferences in your account settings page, or you can contact us at
                        privacy@lenovo.com.
                    </li>
                </ul>
                <p>Testimonials:</p>
                <ul>
                    <li>Lenovo sometimes displays product reviews, testimonials and other endorsements of satisfied
                        customers on our site. With your consent, we may post your comments along with your name. If you
                        want to update or delete your comments, you can contact us at privacy@lenovo.com.
                    </li>
                </ul>
                <p>Service Quality Monitoring:</p>
                <ul>
                    <li>Certain website activities may also involve you calling Lenovo or Lenovo, or its repair
                        providers, calling you. Please note that, in some cases, we may record and retain such calls for
                        staff training and quality assurance purposes. If you do not wish the call to be recorded,
                        please notify the call taker.
                    </li>
                </ul>
                <p>Business Partner Relationships:</p>
                <ul>
                    <li>If you represent a Lenovo business partner (i.e. a distributor or reseller of Lenovo products),
                        you may visit a Lenovo website intended specifically for Lenovo business partners. We may use
                        personal information provided on that site to administer and develop our business relationship
                        with you, and the company you represent. For instance, this may involve using your information
                        to send you details of Lenovo business partner programs. It may also include sharing certain
                        information with other business partners (subject to any confidentiality obligations that may
                        exist), or Lenovo customers or prospects. In connection with a particular transaction or
                        program, we may also contact you as part of customer satisfaction surveys or for market research
                        purposes.
                    </li>
                </ul>
                <p>Supplier Administration:</p>
                <ul>
                    <li>If you represent a Lenovo supplier, you may visit a Lenovo website intended specifically for use
                        by Lenovo suppliers. We may use the information provided on that site in connection with
                        entering into or performing a transaction with you. For example, this may include sharing
                        information with other parts of Lenovo, Lenovo's business partners, customers, shipping
                        companies, financial institutions, postal or government authorities involved in fulfillment of a
                        transaction. It may also be used to administer and develop our relationship with you, the
                        supplier you represent and/or other Lenovo suppliers generally.
                    </li>
                </ul>
                <p>Disclosures Required by Law:</p>
                <ul>
                    <li>In certain circumstances, it is possible that personal information may be subject to judicial or
                        other government subpoenas, warrants, or orders. Therefore, when we believe in good faith that
                        the law requires it, we may disclose personal or other information to regulatory or government
                        bodies, courts of law, tribunals, and law enforcement bodies to protect our rights, protect your
                        safety or the safety of others, investigate fraud, or respond to a government request.
                    </li>
                </ul>
                <p>{'Blogs & Discussion Forms:'}</p>
                <ul>
                    <li>If you participate in a Lenovo blog or discussion forum, you should be aware that the
                        information you provide there may be made broadly available to others, potentially inside or
                        outside Lenovo, who have access to that blog, discussion forum, or chat room. Also, please
                        recognize that individual blogs, forums, and chat rooms may be hosted by organizations other
                        than Lenovo and/or may have additional rules and conditions. Each participant's opinion on a
                        blog, forum or chat room is his or her own and should not be considered as reflecting the
                        opinion of Lenovo.
                    </li>
                </ul>
                <p>{'Social media features & widgets:'}</p>
                <ul>
                    <li>Some of our websites include social media features and links, such as a social bar with icons
                        that link to the Lenovo presence on that specific site (e.g., the Lenovo page on Facebook, the
                        Lenovo feed on Twitter). These features may collect your IP address and information on which
                        page you are visiting on our site, and may set a cookie to enable the feature to function
                        properly. Social media features and widgets are either hosted by another company or are hosted
                        directly on our site. Your interactions with these features are governed by the privacy policy
                        of the company providing it.
                    </li>
                </ul>
                <p>Single Sign On:</p>
                <ul>
                    <li>You can log in to certain areas of our websites using sign-in services, such as Facebook Connect
                        or an Open ID provider. These services will authenticate your identity; provide you the option
                        to share certain personal information (such as your name and email address) with us, and to
                        pre-populate our sign up form. Services like Facebook Connect give you the option to post
                        information about your activities on this website to your profile page to share with others
                        within your network.
                    </li>
                </ul>
                <p>{'Frames & Powered-By Sites:'}</p>
                <ul>
                    <li>Some of our pages use framing techniques to serve content from suppliers or partners while
                        preserving the look and feel of our site. In addition, certain Lenovo-branded websites may be
                        operated by suppliers or partners may be designated by a "powered-by" logo. Please be aware that
                        such sites may be governed by the privacy practices and policies of our suppliers or partners
                        and not necessarily those of Lenovo or Lenovo.com.
                    </li>
                </ul>
                <p>{'Mergers & Acquisitions:'}</p>
                <ul>
                    <li>Circumstances may arise when, whether for strategic or other business reasons, Lenovo decides to
                        sell, buy, merge, or otherwise reorganize businesses in some countries. You will be notified via
                        email and/or a prominent notice on our website of any change in ownership or uses of your
                        personal information, as well as any choices you may have regarding your personal information.
                        Such a transaction may involve the disclosure of personal information to prospective or actual
                        purchasers, or receiving it from sellers.
                    </li>
                </ul>
                <p>Other Sources</p>
                <ul>
                    <li>In addition to the above, there may circumstances which require us to disclose your personal
                        information to parties in addition to those listed above, including, but not limited to, legal
                        advisers or debt collection agencies.
                    </li>
                </ul>

            </div>

            <h3 className={`${styles.marginTp20} ${styles.marginB10}`}>Does Lenovo transfer my personal information
                internationally?</h3>
            <div>
                <p>Lenovo is a global organization, with legal entities, business processes, management structures, and
                    technical systems that cross borders. Therefore, where permitted by law, we may share your personal
                    information within Lenovo (including to subsidiaries, affiliates and parent companies) or our
                    suppliers and business partners and may transfer it to other countries in the world where we do
                    business (including, but not limited to, the United States of America and China). Regardless of
                    where your information is transferred to and resides, our privacy and security practices are
                    designed to provide protection for your personal information globally.</p>
                <p>Please note that some countries have privacy laws that are not equivalent to privacy laws in your own
                    country. In such countries, Lenovo will still handle information in the manner we describe here and
                    will take such measures as are necessary to comply with applicable data protection laws when
                    transferring and processing your information. Where required, Lenovo will also maintain agreements
                    between Lenovo group companies or with Lenovo partners or suppliers to govern the transferring,
                    processing and protection of personal information.</p>
                <p>In addition to the privacy practices set out in this policy, Lenovo’s Motorola Mobility business has
                    established a set of "Binding Corporate Rules" for internal transfers between Motorola Mobility
                    group companies in the European Union and Motorola Mobility group companies elsewhere. These have
                    been approved by certain European Union Data Protection Authorities and are a commitment by Motorola
                    Mobility to adequately protect personal information that Motorola Mobility processes regardless of
                    where the information resides. A full copy of the rules can be found here. For additional
                    information, please contact privacy@lenovo.com.</p>
            </div>

            <h3 className={`${styles.marginTp30} ${styles.marginB10}`}>Does Lenovo use cookies, web beacons, analytics
                and related technologies for online advertising and other purposes?</h3>
            <div>
                <p>As is true of most websites, we collect certain information automatically and store it in log files.
                    We sometimes collect information about our visitor's behavior during their visits to our websites to
                    help us provide better customer service, to improve the quality of our website experiences or to
                    tailor advertising.</p>
                <p>For example, we keep track of the domains from which visitors come to our website, and we also
                    measure visitor activity on Lenovo websites, but we do so in ways that do not enable the actual
                    identity of any visitor (we call this "non-identifiable information" below). Lenovo or others on
                    Lenovo's behalf may use this data to analyze trends and statistics, to improve our websites and to
                    serve targeted advertising.</p>
                <p>Clickstreams:</p>
                <ul>
                    <li>When we collect personal information from you in a transaction, we may extract some information
                        about that transaction in a non-identifiable format and combine it with other non-identifiable
                        information. This information is sometimes called a "clickstream”. This information is used and
                        analyzed only at an aggregate level to help us understand trends and patterns. This information
                        is not reviewed at an individual level.
                    </li>
                </ul>
                <p>Cookies:</p>
                <ul>
                    <li>In order to offer and provide a customized website experience, Lenovo may use cookies, such as
                        GoogleAnalytics and DoubleClick cookies, to store and help track information about you. Cookies
                        are simply small pieces of data that are sent to your browser from a web server and stored on
                        your computer's hard drive. Lenovo uses cookies to help remind us who you are and to help you
                        navigate our sites during your visits. Cookies enable us to save passwords and preferences for
                        you so you won't have to re-enter them each time you visit. We also use cookies in order to
                        determine relevant interest based advertisements to serve the user.
                    </li>
                    <li>
                        <p>Lenovo may also use cookies to measure traffic patterns and which areas of the Lenovo site
                            you have visited and your visiting patterns. Lenovo may use this information to understand
                            how our users navigate our site and to determine common traffic patterns, including what
                            site the user came from. We use this information to simplify site navigation, to make
                            product recommendations and to help design our site in order to make your experience more
                            efficient and enjoyable. The use of cookies is relatively standard. Most browsers are
                            initially set up to accept cookies. However, if you prefer not to store cookies, you can
                            choose to:</p>
                        <ul>
                            <li>not use our sites</li>
                            <li>set your browser to notify you when you receive a cookie</li>
                            <li>set your browser to refuse to accept cookies</li>
                            <li>delete our cookies after visiting our site</li>
                            <li>browse our site using your browser’s anonymous usage setting (called "Incognito" in
                                Chrome, "InPrivate" for Internet Explorer, "Private Browsing" in Firefox and Safari
                                etc.)
                            </li>
                        </ul>
                    </li>
                    <li>However, please note that certain Lenovo websites may not respond to Do-Not-Track signals sent
                        by certain browsers. You should also understand that some features of the Lenovo website may not
                        function properly if you don't accept cookies.
                    </li>
                    <li>If you do not know how to control or delete cookies, or would like to opt-out of receiving
                        certain targeted ads based on your browsing history, we recommend that you visit
                        http://www.networkadvertising.org/choices/, http://www.aboutads.info/, or
                        www.youronlinechoices.eu for detailed guidance, including opt-out instructions.
                    </li>
                    <li>If you would like to opt-out of Google Analytics for Display Advertisers and/or opt out of the
                        customized Google Display Network, you may do so by visiting Google's Ads Preferences Manager.
                        You may also wish to utilize the Google Analytics Opt-out Browser Add-on to opt-out of Google
                        Analytics. For information on how to do this on the browser of your product or mobile device you
                        will need to refer to your browser's or mobile device's help menu or product manual.
                    </li>
                </ul>

                <p>Local Storage Objects:</p>
                <ul>
                    <li>Additionally, we may use local storage objects (LSOs) such as Flash cookies and HTML5 to store
                        content information and preferences. Suppliers and partners with who provide certain features on
                        our site or to display advertising based upon your web browsing activity also use LSOs such as
                        HTML5 to collect and store information. Various browsers may offer their own management tools
                        for removing HTML5 LSOs. To manage Flash cookies, please click here:<br/>
                        <a href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html">http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html</a>
                    </li>
                </ul>

                <p>Online Advertising:</p>
                <ul>
                    <li>Lenovo may also use services hosted by companies, such as Google Analytics for Display
                        Advertisers, Remarketing with Google Analytics, Google Display Network Impression Reporting,
                        DoubleClick Campaign Manager and Google Analytics Demographic and Interest Reporting to assist
                        in providing services to help us understand our customers' use of our websites and products, and
                        to deliver and manage interest-based advertisements. These services may collect information,
                        such as your IP address, sent by your browser or via cookies (for information on how to control
                        these cookies, see the heading "Cookies" above).
                    </li>
                    <li>This information may be used to measure website trends and to deliver a Lenovo product
                        advertisement while browsing a website including non-Lenovo websites. These ads are delivered
                        based on a user’s visit to the Lenovo website. Lenovo and its suppliers, including Google and
                        DoubleClick, use cookies to report how your ad impressions, other uses of ad services, and
                        interactions with these ad impressions and ad services are related to visits to Lenovo’s
                        website.
                    </li>
                    <li>If you don't want to have this information used for the purpose of serving you interest-based
                        ads, you may opt-out. You will still continue to receive generic ads.
                    </li>
                </ul>

                <p>Adobe Marketing Cloud Device Co-Op:</p>
                <ul>
                    <li>Lenovo participates in the Adobe Marketing Cloud Device Cooperative to better understand how you
                        use certain websites and apps of ours across the various devices you use, and to deliver
                        tailored promotions. Learn more about how Adobe does this and how you may opt-out of this
                        program.
                    </li>
                </ul>

                <p>Web beacons and other technologies:</p>
                <ul>
                    <li>Some Lenovo websites also use web beacon or other technologies such as Java scripts and etags to
                        better tailor those sites to provide better customer service. These technologies may be in use
                        on a number of pages across Lenovo websites. When a visitor accesses these pages, a
                        non-identifiable notice of that visit is generated. This may be processed by us or by our
                        suppliers. These web beacons usually work in conjunction with cookies. If you turn off cookies,
                        web beacons and other technologies will still detect visits to these pages, but the notices they
                        generate cannot be associated with other non-identifiable cookie information and are
                        disregarded.
                    </li>
                </ul>

                <p>Personalized URL Links:</p>
                <ul>
                    <li>On occasion, we may personalize and customize websites for certain visitors. If you visit one of
                        these sites, you may find it customized with references to products and/or services that we
                        believe may be of interest to you, based on your previous interactions with Lenovo and
                        information you have provided to us. While you are visiting these websites, we may collect
                        information about your visit to better tailor the site to your interests. An invitation to visit
                        one of these websites can be presented as a personalized URL in an email, a notice on a website
                        registration page, or as a response to you logging on to a certain website.
                    </li>
                    <li>If you choose to visit one of these websites, Lenovo will collect information about your visits
                        and associate with other information about you and your relationship with Lenovo. If you do not
                        want your information to be used in this way, please do not visit these sites.
                    </li>
                </ul>

                <p>How long will my personal information be retained?</p>
                <ul>
                    <li>We will retain your personal information only for as long as your account is active or as needed
                        to provide you with services. We will also retain your personal information as necessary to
                        comply with applicable legal obligations, to resolve disputes, and to enforce our agreements.
                    </li>
                </ul>
            </div>

            <h3 className={`${styles.marginTp20} ${styles.marginB10}`}>How is my information secured?</h3>
            <div>
                <p>Lenovo implements appropriate technical and organizational measures and processes to protect your
                    personal information and to maintain its quality both during transmission and once it is received.
                    For example, we use encryption when transmitting sensitive information such as a credit card number
                    to help us to keep your information secure.</p>
                <p>However, please remember that no data transmission over the Internet can be guaranteed to be 100%
                    secure. As a result, while we have taken appropriate steps to protect your personal information,
                    Lenovo cannot ensure or otherwise warrant the security of any information you provide to us or from
                    our website and therefore you use our site at your own risk. Information on how to report security
                    questions, issues or possible incidents to the Lenovo Information Security Team can be found
                    here.</p>
            </div>

            <h3 className={`${styles.marginTp20} ${styles.marginB10}`}>What about my child’s privacy?</h3>
            <div>
                <p>Websites operated by or on behalf of Lenovo are intended for use by persons age 16 and over. Lenovo
                    does not seek to collect information about children under the age of 16. No information should be
                    submitted to or posted on Lenovo's websites by users under 16 years of age.</p>
                <p>If a child under the age of 16 submits personal information to Lenovo's web sites, we delete the
                    information as soon as we discover it was provided by a child under 16 years of age and do not use
                    it for any purpose. Lenovo encourages parents to take an active role in their child(ren)'s use of
                    the Internet and to inform them of the potential dangers of providing information about themselves
                    over the Internet.</p>
            </div>

            <h3 className={`${styles.marginTp20} ${styles.marginB10}`}>What are my data protection rights?</h3>
            <div>
                <p>Applicable data protection laws may give you the right to control our use and processing of your
                    personal information. These may include the right (i) to request access to and a copy of your
                    personal information, (ii) to object to processing of your personal information, (iii) to request
                    rectification or erasure of your personal information; (iv) to restrict processing or to opt-out of
                    any sale of your personal information; and (v) to data portability. Where we are using your personal
                    information with your consent, you also have the right to withdraw your consent at any time, though
                    this will not affect our uses of your personal information prior to the withdrawal of your
                    consent.</p>
                <p>To exercise any of your rights, please contact us at privacy@lenovo.com. We will consider and act
                    upon any such requests in accordance with applicable data protection laws, and may ask you to verify
                    your identity in order to help us respond efficiently to your request.</p>
                <p>You also have the right to raise questions or complaints with your applicable national data
                    protection authority at any time.</p>
            </div>

            <h3 className={`${styles.marginTp20} ${styles.marginB10}`}>How may I contact the Lenovo Privacy
                Program?</h3>
            <div>
                <p>If you have a question about this privacy policy, you can contact Lenovo via privacy@lenovo.com or
                    via U.S. postal mail at Lenovo, Attn: Privacy Program, 1009 Think Place, Morrisville, North
                    Carolina, USA 27560.</p>
            </div>
        </div>
    </div>
)
